import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import drag from "../../assets/drag.svg";
import React, { useEffect, useState } from "react";
import Pass from "../../components/Common/Pass";
import { get, del, put } from "../../api/axios";
import endpoints from "../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import avatar from "../../assets/images/personPlaceholder.png";
import passDesign1 from "../../../src/assets/peach.svg";
import passDesign2 from "../../../src/assets/green.svg";
import passDesign3 from "../../../src/assets/purple.svg";
import { useSelector } from "react-redux";
const BusinessVerificationDetails = () => {
  document.title = "Business Verification Detail | Elevated - Admin Dashboard";
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const gymId = location.state?.gymId;
  const [gymData, setGymData] = useState(null);
  const [loading, setLoading] = useState(true);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);

  const { appRole, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  useEffect(() => {
    if (gymId) fetchGym(gymId);
  }, [gymId]);

  const fetchGym = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.gym}/${id}`);
      setGymData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching gym data:", error);
      setGymData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleEditGym = () => {
    if (!gymId) {
      toast.error("Gym ID not available, unable to edit.");
      return;
    }

    navigate(`/edit-gyms/:id`, { state: { gymId: gymId } });
  };

  const handleDeleteGym = async () => {
    if (!gymId) {
      toast.error("Gym ID not available, unable to delete.");
      return;
    }

    try {
      await del(`${endpoints.gym}/${gymId}`);
      toast.success(`Gym Deleted Successfully`, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate("/list-gyms");
      setModalOpen(false);
    } catch (error) {
      console.error("Error deleting gym:", error);
      alert("Failed to delete the gym.");
      setModalOpen(false);
    }
  };
  const formatTime = (time) => {
    const [hours, minutes] = time?.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return date.toLocaleTimeString([], options);
  };
  return (
    <div className=" mb-5 ">
      <Container fluid>
        <Card className="rounded-4 p-4" style={{ minHeight: "550px" }}>
          <Row className="justify-content-between align-items-center">
            <Col xs="12" md="6">
              <h2 className="card-title fw-bold ff-sora font-size-20 primary-black">
                Gym Details
              </h2>
            </Col>
            <Col
              xs="12"
              md="6"
              className="d-flex justify-content-center justify-content-md-end"
            >
              {userPermissions?.gym?.["Delete Gym"] && (
                <Button
                  color="white"
                  className="rounded-pill1 me-2 mb-2 mb-md-0"
                  onClick={() => setModalOpen(true)}
                >
                  Delete Gym
                </Button>
              )}
              {userPermissions?.gym?.["Update Gym"] && (
                <Button className="rounded-pill" onClick={handleEditGym}>
                  Edit Gym
                </Button>
              )}
            </Col>
            <Modal
              isOpen={modalOpen}
              toggle={toggleModal}
              className="modal-dialog-centered rounded-4"
            >
              <ModalHeader
                toggle={toggleModal}
                className="font-size-16 fw-medium ff-sora"
              >
                Confirm Deletion
              </ModalHeader>
              <ModalBody className="font-size-14 fw-normal ff-sora">
                Are you sure you want to delete this gym?
              </ModalBody>
              <ModalFooter>
                <Button
                  type="submit"
                  className=" rounded-pill"
                  onClick={handleDeleteGym}
                >
                  Confirm
                </Button>
                <Button
                  color="white"
                  className="rounded-pill1"
                  onClick={toggleModal}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </Row>
          {gymData?.logo && (
            <>
              <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-4">
                Logo
              </h5>
              <img
                src={`${process.env.REACT_APP_IMG_URL}${gymData.logo.data}`}
                className="rounded-3 object-fit-cover mt-1 "
                style={{
                  height: "156px",
                  width: "230px",
                  border: "0.11px solid black",
                }}
                alt={`gym-image-${gymData.logo.data}`}
              />
            </>
          )}
          {loading ? (
            <div className="text-center ff-sora fw-normal font-size-16">
              Loading...
            </div>
          ) : gymData ? (
            <>
              <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-4">
                Media
              </h5>
              {gymData.files && gymData.files.length > 0 ? (
                <Row className="mb-2 g-1">
                  {gymData.files.map((file, index) => (
                    <img
                      key={index}
                      src={`${process.env.REACT_APP_IMG_URL}${file.data}`}
                      className="rounded-3 object-fit-cover mt-1 "
                      style={{
                        height: "156px",
                        width: "230px",
                        border: "0.1px solid black",
                      }}
                      alt={`gym-image-${index}`}
                    />
                  ))}
                </Row>
              ) : (
                <Row className="my-4">
                  <Col
                    sm="12"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <img
                      src={avatar}
                      className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover"
                      alt="default-avatar"
                      style={{
                        width: "200px",
                        height: "150px",
                      }}
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col xs="12" md="8">
                  <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-4">
                    General Info
                  </h5>
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Gym Owner
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData?.gymOwnerId?.firstName}{" "}
                      {gymData?.gymOwnerId?.lastName}
                    </span>
                  </p>
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Gym/Club Title
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData.name}
                    </span>
                  </p>
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Description
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData.description}
                    </span>
                  </p>
                </Col>
              </Row>

              <Row>
                <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                  Contact Info
                </h5>
                <Col xs="12" md="4">
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Contact No
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData.phoneNumber}
                    </span>
                  </p>
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Website
                    </span>
                    <a
                      className="secondary-black font-size-16 ff-sora fw-normal"
                      href={`http://${gymData.website}`}
                    >
                      {gymData.website}
                    </a>
                  </p>
                </Col>
                <Col xs="12" md="6">
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Email
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData.email}
                    </span>
                  </p>
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Location
                    </span>
                    <span className="secondary-black font-size-16 ff-sora fw-normal">
                      {gymData?.location?.formatted_address}
                    </span>
                  </p>
                </Col>
                <Col xs="12" md="6">
                  <p className="d-flex flex-column">
                    <span className="light-black font-size-16 ff-sora fw-normal">
                      Socail Links:
                    </span>
                    <div className="d-flex gap-2">
                      <span className="secondary-black font-size-16 ff-sora fw-normal">
                        <a href={gymData.socialInfo?.facebook}>Facebook </a>
                      </span>{" "}
                      <span className="secondary-black font-size-16 ff-sora fw-normal">
                        <a href={gymData.socialInfo?.instagram}>Instagram </a>
                      </span>
                    </div>
                  </p>
                </Col>
              </Row>

              <Row>
                {gymData.openingSchedule &&
                  gymData.openingSchedule.length > 0 && (
                    <>
                      <Col xs="12" md="8">
                        <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                          Working Hours
                        </h5>
                        <Table className="table-borderless">
                          <tbody style={{ minHeight: "550px" }}>
                            {Array.isArray(gymData.openingSchedule) &&
                              gymData.openingSchedule.map(
                                (_, index) =>
                                  _.openTime && _.closeTime ? (
                                    <tr key={index}>
                                      <td
                                        className="ff-sora border-0 light-black fw-normal font-size-16"
                                        style={{
                                          color: "#9e9e9e",
                                          width: "20%",
                                        }}
                                      >
                                        {_.workingDay}
                                      </td>
                                      <td className="ff-sora border-0 secondary-black fw-normal font-size-16">
                                        {`${formatTime(
                                          _.openTime
                                        )} - ${formatTime(_.closeTime)}`}
                                      </td>
                                    </tr>
                                  ) : null // If no valid openTime/closeTime, skip rendering this row
                              )}
                          </tbody>
                        </Table>
                      </Col>
                    </>
                  )}
              </Row>

              <Row>
                {gymData.amenities && gymData.amenities.length > 0 && (
                  <>
                    <Col xs="12">
                      <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                        Amenities
                      </h5>

                      {gymData?.amenities?.map((_, index) => (
                        <div
                          className="ff-sora secondary-black fw-normal font-size-16 flex-column"
                          key={index + 1}
                        >
                          <div className="d-flex align-items-start ff-sora secondary-black fw-normal font-size-16">
                            <img
                              src={
                                _.image == null
                                  ? avatar
                                  : `${process.env.REACT_APP_IMG_URL}${_.image}`
                              }
                              alt={_.name}
                              style={{
                                width: 30,
                                height: 30,
                                marginRight: 10,
                              }}
                            />
                            <span>{_.name}</span>
                          </div>
                        </div>
                      ))}
                    </Col>
                  </>
                )}
              </Row>

              <Row>
                <Col xs="12" md="8">
                  {gymData.specialInfo && gymData.specialInfo.length > 0 && (
                    <>
                      <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                        Special Info
                      </h5>
                      <ul>
                        {gymData.specialInfo.map((_, index) => (
                          <li
                            className="ff-sora secondary-black fw-normal font-size-16"
                            key={index + 1}
                          >
                            {_}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </Col>
              </Row>

              <Row className="g-1 flex-wrap">
                {gymData.Pass && gymData.Pass.length > 0 && (
                  <>
                    {gymData.Pass.length > 0 && (
                      <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                        Gym Passes
                      </h5>
                    )}
                    {Array.isArray(gymData.Pass) &&
                      gymData.Pass.map((_, index) => (
                        <Col xs={12} sm={12} md={6} lg={6} xl={4} key={index}>
                          <Pass
                            name={_.name}
                            price={
                              Math.round(parseFloat(_.price) * 10) === 1
                                ? `${Math.round(parseFloat(_.price) * 10)} coin`
                                : `${Math.round(
                                    parseFloat(_.price) * 10
                                  )} coins`
                            }
                            duration={_.duration}
                            filter={
                              _.duration === "oneday"
                                ? passDesign1
                                : _.duration === "oneweek"
                                ? passDesign2
                                : passDesign3
                            }
                            address={gymData?.address
                              ?.split(" ")
                              .slice(1, 4)
                              .join(" ")}
                            createdAt={_?.createdAt}
                          />
                        </Col>
                      ))}
                  </>
                )}
              </Row>
              <Row>
                {" "}
                {gymData.Pass && gymData.Pass.length > 0 && (
                  <>
                    <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                      Sold Passes
                    </h5>

                    <Table className="">
                      <tbody style={{ minHeight: "550px" }}>
                        {Array.isArray(gymData.Pass) &&
                          gymData.Pass.map((_, index) => (
                            <tr
                              className="d-flex flex-row flex-wrap"
                              key={index}
                            >
                              <Col
                                md={2}
                                sm={6}
                                xs={6}
                                className="d-flex flex-column align-items-start"
                              >
                                <td
                                  className="ff-sora border-0 light-black fw-normal font-size-16"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Pass Title
                                </td>
                                <td className="ff-sora border-0 secondary-black fw-normal font-size-16">
                                  {_.name}
                                </td>
                              </Col>
                              <Col
                                md={2}
                                sm={6}
                                xs={6}
                                className="d-flex flex-column"
                              >
                                <td
                                  className="ff-sora border-0 light-black fw-normal font-size-16"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Pass Type
                                </td>
                                <td className="ff-sora border-0 secondary-black fw-normal font-size-16">
                                  {_.duration === "oneday"
                                    ? "Daily"
                                    : _.duration === "oneweek"
                                    ? "Weekly"
                                    : _.duration === "onemonth"
                                    ? "Monthly"
                                    : "N/A"}
                                </td>
                              </Col>
                              <Col
                                md={2}
                                sm={6}
                                xs={6}
                                className="d-flex flex-column"
                              >
                                <td
                                  className="ff-sora border-0 light-black fw-normal font-size-16"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Pass Price
                                </td>
                                <td className="ff-sora border-0 secondary-black fw-normal font-size-16">
                                  ${_.price}
                                </td>
                              </Col>
                              <Col
                                md={2}
                                sm={6}
                                xs={6}
                                className="d-flex flex-column"
                              >
                                <td
                                  className="ff-sora border-0 light-black fw-normal font-size-16"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Total Sold
                                </td>
                                <Col
                                  md={2}
                                  sm={6}
                                  xs={6}
                                  className="ff-sora border-0 secondary-black fw-normal font-size-16"
                                >
                                  {_.coinsPrice == null ? "0" : _.coinsPrice}
                                </Col>
                              </Col>
                              <Col
                                md={2}
                                sm={6}
                                xs={6}
                                className="d-flex flex-column"
                              >
                                <td
                                  className="ff-sora border-0 light-black fw-normal font-size-16"
                                  style={{ color: "#9e9e9e" }}
                                >
                                  Added On
                                </td>
                                <td className="ff-sora border-0 secondary-black fw-normal font-size-16">
                                  {_.createdAt
                                    ? new Date(_.createdAt).toLocaleDateString()
                                    : "01-01-2025"}
                                </td>
                              </Col>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </>
                )}{" "}
              </Row>
              <Row>
                {gymData.Equipment && gymData.Equipment.length > 0 && (
                  <>
                    <h5 className="ff-sora secondary-black fw-normal font-size-16 mt-2">
                      Work Equipment
                    </h5>
                    {Array.isArray(gymData.Equipment) &&
                      gymData.Equipment.map((_, index) => (
                        <Row
                          className="d-flex justify-content-start my-2"
                          key={index}
                        >
                          <Col
                            md={3}
                            xs={12}
                            className="d-flex flex-column justify-content-center"
                          >
                            <div className="d-flex flex-row justify-content-start  align-items-center">
                              <img
                                src={drag}
                                alt="Gym"
                                className="rounded mb-md-0 d-none d-sm-none d-lg-block me-5"
                                height={24}
                                width={24}
                              />

                              <img
                                src={`${process.env.REACT_APP_IMG_URL}${_.file}`}
                                alt="Gym"
                                className="rounded object-fit-cover "
                                height={80}
                                width={120}
                              />
                            </div>
                          </Col>
                          <Col
                            md={3}
                            xs={12}
                            className="d-flex flex-column justify-content-center"
                          >
                            <div className="d-flex flex-column">
                              <span className="font-size-16 fw-normal ff-sora light-black">
                                Equipment Name
                              </span>
                              <span className="font-size-16 fw-normal ff-sora secondary-black">
                                {_.name}
                              </span>
                            </div>
                          </Col>
                          <Col
                            md={3}
                            xs={12}
                            className="d-flex flex-column justify-content-center"
                          >
                            <span className="font-size-16 fw-normal ff-sora light-black">
                              Brand Name
                            </span>
                            <span className="font-size-16 fw-normal ff-sora secondary-black">
                              {_.brand}
                            </span>
                          </Col>
                          <Col
                            md={3}
                            xs={12}
                            className="d-flex flex-column justify-content-center"
                          >
                            <span className="font-size-16 fw-normal ff-sora light-black">
                              Category
                            </span>
                            <span className="font-size-16 fw-normal ff-sora secondary-black">
                              {_.category}
                            </span>
                          </Col>
                        </Row>
                      ))}
                  </>
                )}
              </Row>
            </>
          ) : (
            <div>No pass data available</div>
          )}
        </Card>
      </Container>
    </div>
  );
};

export default BusinessVerificationDetails;
